import { MutationTree } from 'vuex';
import { State } from './state';
import {
  SET_USER_LIST,
  SET_REGISTER_USER_FORM_VISIBILITY,
  SET_SELECTED_USER,
  ADD_USER_TO_LIST,
  SET_USER_PROFILES,
  SET_CURRENT_USER_TAB,
  SET_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  SET_USER_FUNCTIONALITY_RESTRICTIONS,
  SET_CLIENT_CONTRACTS,
  SET_USER_BONDS_LIST,
  SET_SELECTED_BOND,
  ADD_BOND_TO_LIST,
  SET_LOCALE_TYPES_LIST,
  SET_CONFIRMATION_EMAIL, SET_ROLE_CLASSIFICATIONS,
} from './types';
import { IProfile } from '@/modules/profile/models';
import { IUser } from '@/modules/user/models';
import { IClientContract } from '@/models/ClientContract';
import { IBond } from '@/models/Bond';
import {IRoleClassification} from '@/models/IRoleClassification';

export const mutations: MutationTree<State> = {
  [SET_USER_LIST](state: State, payload: IUser[]) {
    state.users = payload;
  },
  [SET_REGISTER_USER_FORM_VISIBILITY](state: State, payload: boolean) {
    state.showRegisterForm = payload;
  },
  [SET_SELECTED_USER](state: State, payload: IUser) {
    state.userSelected = payload;
  },
  [ADD_USER_TO_LIST](state: State, payload: IUser) {
    state.users.push(payload);
  },
  [SET_USER_PROFILES](state: State, payload: IProfile[]) {
    state.userSelected.profiles = payload.map((c) => c.id);
  },
  [SET_CURRENT_USER_TAB](state: State, payload: string) {
    state.currentTab = payload;
  },
  [SET_USER_PROFILE_FUNCTIONALITIES_GROUPED](state: State, payload: any[]) {
    state.groupedProfileFunctionalities = payload;
  },
  [SET_USER_FUNCTIONALITY_RESTRICTIONS](state: State, payload: number[]) {
    state.userSelected.functionalityrestrictions = payload;
  },
  [SET_CLIENT_CONTRACTS](state: State, payload: IClientContract[]) {
    state.clientContracts = payload;
  },
  [SET_USER_BONDS_LIST](state: State, payload: IBond[]) {
    state.userBonds = payload;
  },
  [SET_SELECTED_BOND](state: State, payload: IBond) {
    state.bondSelected = payload;
  },
  [ADD_BOND_TO_LIST](state: State, payload: IBond[]) {
    state.userBonds.push(...payload);
  },
  [SET_LOCALE_TYPES_LIST](state: State, payload: any[]) {
      state.localeTypes = payload;
  },
  [SET_CONFIRMATION_EMAIL](state: State, payload: Date) {
     state.userSelected.confirmationdateemail = payload;
     console.log(state.userSelected.confirmationdateemail);
  },
  [SET_ROLE_CLASSIFICATIONS](state: State, payload: IRoleClassification[]) {
    state.roleClassifications = payload;
  },
};
